// extracted by mini-css-extract-plugin
export default {"wrapper":"WishlistPage_wrapper__IN3cW","heading":"WishlistPage_heading__tejtK","title":"WishlistPage_title__Ffh55","count":"WishlistPage_count__zeHo4"};